import { FormHelperText } from '@mui/material';
import { ValidationErrorMessage } from 'ra-core';
import { FieldError, useFormState } from 'react-hook-form';

type ReactAdminFieldError = FieldError & {
  message?: ValidationErrorMessage;
};

const getErrorMessage = (error?: ReactAdminFieldError) => {
  if (!error?.message) {
    return '';
  }

  if (typeof error.message === 'string') {
    return error.message;
  }

  return error.message['message'] ?? '';
};

export const FileInputHelperText = () => {
  const { errors } = useFormState();
  const errorMessage: string = getErrorMessage(errors._files as ReactAdminFieldError);

  if (!errorMessage) {
    return null;
  }

  return (
    <>
      {errorMessage
        .split(',')
        .map(message => message.trim())
        .filter(Boolean)
        .map(message => (
          <FormHelperText key={message} error sx={{ mt: 0.5 }}>
            {message}
          </FormHelperText>
        ))}
    </>
  );
};
